import { computed, Injectable, signal, Signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageOptions } from '../../shared/utils/types';

@Injectable({
  providedIn: 'root',
})
export class Language {
  private _language = signal<LanguageOptions>('en');
  language: Signal<LanguageOptions> = this._language.asReadonly();

  direction = computed<'ltr' | 'rtl'>(() =>
    this.language() === 'ar' ? 'rtl' : 'ltr'
  );

  constructor(private translate: TranslateService) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');

    const savedLang = localStorage.getItem('app-lang') as LanguageOptions;
    const browserLang = navigator.language.startsWith('ar') ? 'ar' : 'en';
    const langToUse = savedLang && ['en', 'ar'].includes(savedLang) ? savedLang : browserLang;

    this.setLanguage(langToUse);
  }

  setLanguage(lang: LanguageOptions) {
    if (!['en', 'ar'].includes(lang)) lang = 'en';
    this._language.set(lang);
    localStorage.setItem('app-lang', lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang === 'ar' ? 'ar' : 'en';
    this.translate.use(lang);
  }

  toggleLanguage() {
    const newLang: LanguageOptions = this._language() === 'en' ? 'ar' : 'en';
    this.setLanguage(newLang);
  }
}
